import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/home/runner/work/medprev-web-app/medprev-web-app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/app/_components/error-boundary.component.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/app/(main)/(pages)/_metadata/socialmedialogo-medprev.png");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/components/ui/breadcrumb.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/components/ui/link/link.component.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/graphql/create-apollo-client.client.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/logger/datadog.transport.ts");
